import {
  buildCategorySearchOptions,
  buildBloomreachSearchUrl,
  buildBloomreachCacheKey,
} from "~/lib/bloomreach/query-builders";
import { resolveBloomreachCredentials, BLOOMREACH_DEFAULT_ROWS } from "~/lib/bloomreach/config";
import { computePriceFacetStats, setPrefetchedPriceBounds } from "~/lib/bloomreach/cache.svelte";
import type { BloomreachFacetCounts } from "~/lib/bloomreach/types";

const el = document.querySelector('[data-island="plp"]') as HTMLElement | null;
if (el) {
  const collectionKey = el.dataset["propsCollectionKey"] ?? "";

  let rows = BLOOMREACH_DEFAULT_ROWS;
  const dataProps = el.getAttribute("data-props");
  if (dataProps) {
    try {
      const parsed = JSON.parse(dataProps) as { rows?: number };
      if (typeof parsed.rows === "number") rows = parsed.rows;
    } catch {
      // malformed JSON — fall back to default rows
    }
  }

  const config = resolveBloomreachCredentials({});

  if (config.accountId && config.domainKey && collectionKey) {
    const options = buildCategorySearchOptions({
      collectionKey,
      currentUrl: window.location.href,
      rows,
      start: 0,
    });

    // fetchUrl carries the real _br_uid_2 cookie for accurate Bloomreach session tracking.
    // key uses the stable placeholder so it always matches the adoption check in
    // create-plp-listing.svelte.ts, regardless of when BrTrk writes the cookie.
    const fetchUrl = buildBloomreachSearchUrl(config, collectionKey, options);
    const key = buildBloomreachCacheKey(config, collectionKey, options);

    // Unvalidated — Finding F3's schema check happens at the adoption site
    // (create-plp-listing.svelte.ts), not here, so this early-boot script doesn't pay for
    // valibot's module graph on every PLP load. See globals.d.ts's plpPrefetch comment.
    const promise = fetch(fetchUrl).then((r) => {
      if (!r.ok) throw new Error(String(r.status));
      return r.json();
    });

    // This request is always unfiltered (no activeFilters passed above), so its price
    // stats are the true catalog range — seed the slider bounds ratchet with them even
    // when the page loads with a price filter already active and this response never
    // gets adopted as page-1 data (key mismatch below). See setPrefetchedPriceBounds.
    // Best-effort only: computePriceFacetStats throwing on a malformed facet_counts
    // shape is caught below same as a network failure — this seeds a slider bound, it
    // isn't the page's own error state.
    promise
      .then((data) => {
        const stats = computePriceFacetStats(
          (data as { facet_counts?: BloomreachFacetCounts }).facet_counts,
        );
        if (stats.min !== undefined || stats.max !== undefined) setPrefetchedPriceBounds(stats);
      })
      .catch(() => {});

    window.DUSK ??= {} as NonNullable<Window["DUSK"]>;
    window.DUSK.plpPrefetch = { key, promise };
  }
}
